import React from 'react'

const HighlightedEvent = () => {
  return (
    <div>HighlightedEvent</div>
  )
}

export default HighlightedEvent